import { OPERATION_STATUS } from "../../config/axios.init";
import { callAPI } from "../../config/AxiosTemplate"
import { API } from "../../constants/APIConstants"
import { SET_NOTES_REF } from "../../redux/constants";
export const getNoteTypesAction = (requestData,callback) => {
    
    callAPI(
        "GetNoteTypes",
        API.getNoteTypes.concat(requestData),
        "GET",
        {},
        (apiResponse) => {
            if(apiResponse.status === OPERATION_STATUS.SUCCESS) {
                callback(apiResponse);
            }
        }
    );
};
export const getUserRolesAction =
  (isAddUser, callback) => {
    let requestString = "/roles";
    if (isAddUser !== undefined && isAddUser === true) {
      requestString = requestString + "?type=1";
    }
    callAPI(
      "GetUserRoles",
      API.getUserRoles.replace("/roles", requestString),
      "GET",
      {},
      (apiResponse) => {
        if (apiResponse.status === OPERATION_STATUS.SUCCESS) {
          callback(apiResponse);
        }
      }
    );
  };
export const getNotesAction = (requestData,callback) => {
    callAPI(
        "GetNotes",
        API.getNotesContext,
        "POST",
        requestData,
        (apiResponse) => {
            if(apiResponse.status === OPERATION_STATUS.SUCCESS) {
                callback(apiResponse);
            }
        }
    )
}

export const setNotesRefAction = (notesRef) => (dispatch) => {
  dispatch({
    type: SET_NOTES_REF,
    NotesRef: notesRef,
  });
};
